﻿/*
 * settings required to allow signalr to work
 * refer to:
 * https://github.com/aspnet/SignalR/issues/1014#issuecomment-336254794
 */
window.paceOptions = {
    ajax: false,
    restartOnRequestAfter: false
};